export default "__VITE_ASSET__5VDlgfy3__"